var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #15a7ff;\n        opacity: 0;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark_container",
    "data-name": "checkmark container",
    transform: "translate(-0.383 0.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "checked_box",
    "data-name": "checked box",
    className: "cls-1",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(0.383 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "new_checkmark",
    "data-name": "new checkmark",
    className: "cls-2",
    d: "M475.743-484.9a1.7,1.7,0,0,1-1.7-1.7,1.7,1.7,0,0,1,1.7-1.7h1.9v-4.9a1.7,1.7,0,0,1,1.7-1.7,1.7,1.7,0,0,1,1.7,1.7v6.594s0,0,0,0,0,0,0,0a1.7,1.7,0,0,1-1.7,1.7Z",
    transform: "translate(-675.691 15.737) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.c290345caa23cdfdd31ded5d52ef24d3.svg";
export { ForwardRef as ReactComponent };